exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tag-engagement-popper-cls {\n  border-radius: 0.026042rem !important;\n  width: 4.166667rem;\n}\n.tag-engagement-popper-cls-en {\n  border-radius: 0.026042rem !important;\n  width: 4.6875rem;\n}", ""]);

// exports
